import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ExoticComponent } from 'react';

import { GameWidgetKey } from '@ezugi/types';

export type MenuSetPayload = Partial<MenuState>;

export type MenuWidget = {
  key: GameWidgetKey;
  label?: string;
  'data-e2e': string;
  icon: string;
  svg: string;
  onClick: () => void;
  drawer?: boolean;
  widget: MenuWidget;
  render?: ExoticComponent;
  drawerBackIcon?: boolean;
  keepMenu?: boolean;
}

export type MenuState = {
  open: boolean;
  widget: Partial<MenuWidget>;
}

const initialState: MenuState = {
  open: false,
  widget: {},
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    set(state, { payload } : PayloadAction<MenuSetPayload>) {
      return {
        ...state,
        ...payload,
      };
    },
    toggle(state) {
      return {
        ...state,
        widget: {},
        open: !state.open,
      };
    },
  },
});

export const menuActions = menuSlice.actions;
export default menuSlice.reducer;
